var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteForFriend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25297",
    "data-name": "Rectangle 25297",
    width: 21,
    height: 25,
    transform: "translate(0 0.5)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87436",
    "data-name": "Group 87436",
    transform: "translate(0 -0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87435",
    "data-name": "Group 87435",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87437",
    "data-name": "Group 87437",
    transform: "translate(9.05 17.827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275618",
    "data-name": "Path 275618",
    d: "M193.629,367h-.972a.486.486,0,0,0-.486.486v3.888a.486.486,0,0,0,.486.486h.973a2.617,2.617,0,0,0,0-4.859m0,3.888h-.486v-.972h.485a.486.486,0,1,1,0,.972m0-1.944h-.485v-.972h.485a.486.486,0,1,1,0,.972",
    transform: "translate(-192.171 -367)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275619",
    "data-name": "Path 275619",
    d: "M267.916,368.458A1.459,1.459,0,0,0,266.458,367h-.972a.486.486,0,0,0-.486.486v3.888a.486.486,0,1,0,.972,0v-1.458h.186l.838,1.675a.486.486,0,1,0,.869-.435l-.709-1.419a1.459,1.459,0,0,0,.761-1.28m-1.944-.486h.486a.486.486,0,0,1,0,.972h-.486Z",
    transform: "translate(-261.461 -367)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275620",
    "data-name": "Path 275620",
    d: "M336.459,367h0A1.464,1.464,0,0,0,335,368.458V370.4a1.458,1.458,0,0,0,2.916,0v-1.945A1.464,1.464,0,0,0,336.459,367m.485,3.4a.486.486,0,1,1-.972,0v-1.942a.486.486,0,1,1,.972,0Z",
    transform: "translate(-328.059 -367)",
    fill: "#fd930d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_275621",
    "data-name": "Path 275621",
    d: "M114.092,0a2.432,2.432,0,0,0-2.43,2.43V6.87A2.426,2.426,0,0,0,108.1,7.6a2.419,2.419,0,0,0-3.918.5A2.428,2.428,0,0,0,100,9.784V20.058a1.863,1.863,0,0,0,1.367,1.785V23.8a1.085,1.085,0,0,0,1.08,1.079h13a1.085,1.085,0,0,0,1.079-1.08V2.43A2.432,2.432,0,0,0,114.092,0m-1.458,2.43a1.458,1.458,0,1,1,2.916,0v8.138a2.423,2.423,0,0,0-1.458-.492h-1.458Zm-3.888,6.383a1.458,1.458,0,1,1,2.916,0v1.263h-2.916Zm-3.888.439a1.458,1.458,0,1,1,2.916,0V12.5a1.458,1.458,0,1,1-2.916,0Zm-3.888.533a1.458,1.458,0,1,1,2.916,0v2.721h0v.532a1.458,1.458,0,1,1-2.916,0ZM115.55,23.8a.11.11,0,0,1-.108.11H102.448a.11.11,0,0,1-.11-.108V21.423a.486.486,0,0,0-.484-.486.887.887,0,0,1-.882-.881V14.978a2.417,2.417,0,0,0,3.6-.793,2.416,2.416,0,0,0,3.692-.228,2.437,2.437,0,0,0,1.944.979h1.458v1.2a.486.486,0,1,0,.972,0V14.449a.486.486,0,0,0-.486-.486h-1.942a1.467,1.467,0,0,1-1.459-1.458V11.048h5.344a1.467,1.467,0,0,1,1.459,1.459Z",
    transform: "translate(-95.429 -0.007)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275622",
    "data-name": "Path 275622",
    d: "M1.215,10H9.109a1.218,1.218,0,0,1,1.215,1.215v6.074A1.218,1.218,0,0,1,9.109,18.5h-2v2.43L4.676,18.5H1.215A1.218,1.218,0,0,1,0,17.289V11.215A1.218,1.218,0,0,1,1.215,10m3.947,2.689c-1.015-1.015-2.848.132-1.851,1.858A4.076,4.076,0,0,0,5.162,16.2a4.077,4.077,0,0,0,1.851-1.648C8.01,12.821,6.177,11.674,5.162,12.689Z",
    transform: "translate(-0.289 -9.521)",
    fill: "#ffded7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275623",
    "data-name": "Path 275623",
    d: "M54.884,52.366a.486.486,0,0,1-.126-.017,4.5,4.5,0,0,1-2.146-1.875,1.932,1.932,0,0,1,.325-2.609,1.715,1.715,0,0,1,1.947-.106,1.714,1.714,0,0,1,1.947.106,1.932,1.932,0,0,1,.325,2.609,4.5,4.5,0,0,1-2.147,1.875.486.486,0,0,1-.126.017m-.89-3.887a.772.772,0,0,0-.465.158c-.287.22-.457.691-.075,1.352a3.962,3.962,0,0,0,1.431,1.372,3.963,3.963,0,0,0,1.431-1.372c.382-.661.211-1.132-.075-1.352a.754.754,0,0,0-1.012.08.486.486,0,0,1-.687,0,.763.763,0,0,0-.547-.238",
    transform: "translate(-50.011 -45.205)",
    fill: "#fd930d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteForFriend);
export default __webpack_public_path__ + "static/media/Quote_for_Friend.a57907a9b9839e7e3a042b56ced230cb.svg";
export { ForwardRef as ReactComponent };